module.exports = "/_next/static/images/a6a77a829b916eff5e2b1bd8ec3c492e-phone-with-app-open-and-card@2x-lg.jpg.webp";